import { applyFontFallbacksString } from '../font-utils';
export var handleFontFamilyFallbacks = function (span) {
    var fontFamily = span.css('font-family');
    if (fontFamily) {
        span.css('font-family', applyFontFallbacksString(fontFamily));
    }
};
//# sourceMappingURL=handle-font-family-fallbacks.js.map